import { render, staticRenderFns } from "./ImportUsers.vue?vue&type=template&id=2fd3fc7d&"
import script from "./ImportUsers.vue?vue&type=script&lang=js&"
export * from "./ImportUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports